export default __webpack_public_path__ + "static/media/montage-LMTR_4.f9335843.jpeg";